import React, { useEffect, useState } from 'react';
import { MarketList, MarketRow, MarketSelect } from '@market/react';

const QuantityDropdown = (props) => {
  const {
    disabled = false,
    label = '',
    value = 1,
    limit = 9,
    onQtyChange = () => {},
  } = props;

  const [val, setVal] = useState(value.toString());

  useEffect(() => setVal(value.toString()), [value]);

  const rows = [];
  for (let i = 1; i <= limit; i++) {
    rows.push(
      <MarketRow key={i} value={i.toString()}>
        {i}
      </MarketRow>,
    );
  }

  return (
    <MarketSelect
      {...(disabled && { disabled: true })}
      value={val}
      onMarketSelectValueDidChange={(e) => {
        const newQty = Number.parseInt(e.detail.value, 10);
        setVal(newQty.toString());
        onQtyChange(newQty);
        return e.target.closeList?.();
      }}
      style={{ width: '90px', height: '70px' }}
    >
      <label>{label}</label>
      <MarketList slot="list">{rows}</MarketList>
    </MarketSelect>
  );
};

export default QuantityDropdown;
